const topojsonClient = require('topojson-client')

export function convertToGeoJSON(data) {
  if (!data) return data

  if (data.type === 'FeatureCollection') {
    return data
  }

  if (data.type === 'Topology' && data.objects) {
    const objectNames = Object.keys(data.objects)
    if (objectNames.length > 0) {
      return topojsonClient.feature(data, data.objects[objectNames[0]])
    }
  }

  return data
}

export function getGeoJSONBBox(geojson) {
  if (!geojson || !geojson.features || !geojson.features.length) return null

  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity

  const processCoordinates = (coords) => {
    if (Array.isArray(coords[0])) {
      coords.forEach(processCoordinates)
    } else if (typeof coords[0] === 'number') {
      const [lng, lat] = coords
      if (lng < minX) minX = lng
      if (lng > maxX) maxX = lng
      if (lat < minY) minY = lat
      if (lat > maxY) maxY = lat
    }
  }

  geojson.features.forEach((f) => {
    if (f.geometry && f.geometry.coordinates) {
      processCoordinates(f.geometry.coordinates)
    }
  })

  if (minX === Infinity) return null

  return [minX, minY, maxX, maxY]
}
